import React, { useRef, useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import styles from './Css/CategoriesList.module.css';

import { setGoodsParamsReducer } from './../../Redux/Reducers/goodsReducer';
import SexyButton from './../Buttons/SexyButton';
import { useTranslation } from 'react-i18next';
import Button from "@mui/material/Button";
import ListItemButton from "@mui/material/ListItemButton";

const CategoriesScroll = ({ handleInputBlur, handleOpenBackdrop, handleChangeCategoryID, activeIndex, setActiveIndex, searchText = null, styleMargin = null }) => {
    const categoriesList = useSelector(state => state.shop.categories);
    const ShopSettings = useSelector(state => state.shop.shop.settings);
    const activeIndicatorRef = useRef(null);
    const buttonsContainerRef = useRef(null);
    const buttonRefs = useRef([]);
    const dispatch = useDispatch();
    const Params = useSelector(state => state.goods.params);
    const [isSet, isSetControl] = useState(false);
    const {t} = useTranslation();

    const isFirstRender = useRef(0);

    const selectCategory = (categoryID) => {
        setActiveIndex(categoryID);
        handleInputBlur?.();
    };

    useEffect(() => {
        if (isFirstRender.current < 2) {
            isFirstRender.current += 1;
        } else {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
        }

        async function updateParams() {

            if(searchText === null && ShopSettings.show === undefined) {
                handleOpenBackdrop();
            }
            handleChangeCategoryID(activeIndex);
            const currentParams = {
                ...Params,
                categoryID: activeIndex,
            };
            await dispatch(setGoodsParamsReducer(currentParams));

        }

        if (buttonRefs.current[activeIndex]) {
            const button = buttonRefs.current[activeIndex];
            button.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'center' });

            const { offsetLeft, clientWidth } = button;
            if (activeIndicatorRef.current) {
                activeIndicatorRef.current.style.transform = `translateX(${offsetLeft}px)`;
                activeIndicatorRef.current.style.width = `${clientWidth}px`;
            }
        }

        updateParams();
    }, [activeIndex, Object.values(categoriesList).length]);

    if(Object.values(categoriesList).length > 0) {
        if(ShopSettings.hide_main_category === true && !isSet) {
            setActiveIndex(categoriesList[0].id);
            isSetControl(true);
        }
    }

    if(Object.values(categoriesList).length < 1) {
        return ("");
    }
    return (
        <React.Fragment>
            <div
                ref={buttonsContainerRef}
                className="storefront-categories-list"
                role="tablist"
                style={{ display: 'flex', overflowX: 'auto', position: 'relative' }}
            >
                {
                    ShopSettings.hide_main_category === false && (
                        <ListItemButton
                            className="storefront-category-chip"
                            role="tab"
                            aria-selected={activeIndex === 0}
                            ref={(el) => (buttonRefs.current[0] = el)}
                            onClick={() => selectCategory(0)}
                            sx={{
                                color: 'var(--tg-theme-text-color)',
                                padding: '3px 7px',
                                minWidth: 'auto',
                                maxWidth: "max-content",
                                minHeight: "32px",
                                maxHeight: "32px"
                            }}
                        >
                            <b>{t('mainCategory')}</b>
                        </ListItemButton>
                    )
                }
                {Object.values(categoriesList).map((category) => (
                    <React.Fragment key={category.id}>
                        {
                            searchText ? (
                                category.title.toLowerCase().includes(searchText.toLowerCase()) ? (
                                    <ListItemButton
                                        className="storefront-category-chip"
                                        role="tab"
                                        aria-selected={activeIndex === category.id}
                                        ref={(el) => (buttonRefs.current[category.id] = el)}
                                        onClick={() => {
                                            selectCategory(category.id);
                                        }}
                                        sx={{
                                            color: 'var(--tg-theme-text-color)',
                                            padding: '3px 7px',
                                            minWidth: 'auto',
                                            maxWidth: "max-content",
                                            minHeight: "32px",
                                            maxHeight: "32px"
                                        }}
                                    >
                                        <b>{category.title}</b>
                                    </ListItemButton>
                                ) : null
                            ) : (
                                <ListItemButton
                                    className="storefront-category-chip"
                                    role="tab"
                                    aria-selected={activeIndex === category.id}
                                    ref={(el) => (buttonRefs.current[category.id] = el)}
                                    onClick={() => selectCategory(category.id)}
                                    sx={{
                                        color: 'var(--tg-theme-text-color)',
                                        padding: '3px 8px',
                                        minWidth: 'auto',
                                        maxWidth: "max-content",
                                        minHeight: "32px",
                                        maxHeight: "32px"
                                    }}
                                >
                                    <b>{category.title}</b>
                                </ListItemButton>
                            )
                        }
                    </React.Fragment>
                ))}
                <div ref={activeIndicatorRef} style={{
                    height: '2px',
                    position: 'absolute',
                    bottom: 0,
                    transition: 'all 0.3s ease',
                    borderRadius: 6
                }} className="mainButton storefront-category-indicator" />
            </div>
        </React.Fragment>
    );
};

export default CategoriesScroll;
